<template>
  <router-link v-if="to" :to="to" class="pl-icon-button" :aria-label="label">
    <slot />
  </router-link>
  <button v-else type="button" class="pl-icon-button" :aria-label="label">
    <slot />
  </button>
</template>

<script setup>
// Okrągły przycisk 38 px (ustawienia, awatar, powrót).
defineProps({
  label: { type: String, required: true },
  to: { type: [String, Object], default: null }
})
</script>

<style scoped>
.pl-icon-button {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid var(--pl-color-border-subtle);
  border-radius: var(--pl-radius-pill);
  background: var(--pl-color-bg-card);
  color: var(--pl-color-text-secondary);
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.pl-icon-button:hover {
  background: var(--pl-color-bg-raised);
}
</style>
